import { Component } from '@angular/core';
import {
  BaseTableFilter,
  FilterKeyConditionType,
} from '@clean-code/shared/components/ui-data-table';

@Component({
    selector: 'time-series-identifier-search',
    templateUrl: './time-series-analysis-identifier-search.component.html',
    standalone: false
})
export class TimeSeriesAnalysisIdentifierSearchComponent extends BaseTableFilter {
  setFilterKeyConditions(): FilterKeyConditionType[] {
    return [];
  }
}
